module.exports = __webpack_public_path__ + "img/zhaohuiReport.ab9c7cfa.png";